"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentGravity = void 0;
/**
 * 块位置/块说明位置
 */
var ContentGravity;
(function (ContentGravity) {
    ContentGravity["LEFT"] = "LEFT";
    ContentGravity["CENTER"] = "CENTER";
    ContentGravity["RIGHT"] = "RIGHT";
})(ContentGravity = exports.ContentGravity || (exports.ContentGravity = {}));
